import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCA = function FlagCA() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M50 25c0-9.912-5.768-18.476-14.13-22.52v45.038C44.232 43.475 50 34.911 50 25ZM0 25c0 9.91 5.768 18.475 14.13 22.518V2.48C5.768 6.524 0 15.088 0 25ZM29.348 28.261l4.348-2.174L31.522 25v-2.174L27.174 25l2.174-4.348h-2.174L25 17.392l-2.174 3.26h-2.174L22.826 25l-4.348-2.174V25l-2.174 1.087 4.348 2.174-1.087 2.174h4.348v3.26h2.174v-3.26h4.348l-1.087-2.174Z"
  }));
};
FlagCA.displayName = 'FlagCA';
export default withFlagWrapper(FlagCA);
//# sourceMappingURL=index.js.map